// extracted by mini-css-extract-plugin
export default {"GiftGiverActions__Loader":"GiftGiverActions-styles__GiftGiverActions__Loader__QzSK_"};